import type { RibbonId } from 'owa-ribbon-ids';
import { MailRibbonGroupId, MailRibbonControlId } from 'owa-ribbon-ids';
import { MenuItemType } from 'owa-mail-filterable-menu-behavior';

let MailRibbonIdToCmdIdMap: Map<RibbonId, MenuItemType>;

export const getCmdIdFromRibbonId = (ribbonId: RibbonId): number => {
    if (!MailRibbonIdToCmdIdMap) {
        initializeRibbonIdToCmdIdMap();
    }

    // The map may not contain btnIdentifier, and the resulting commandId would be undefined. Check for that.
    return MailRibbonIdToCmdIdMap.get(ribbonId) ?? MenuItemType.BadItemType;
};

/**
 * Initializes the map that maps RibbonIds to MenuItemTypes.
 * Used in @see {getIsButtonDisabled} to track whether a button should show or not in the Ribbon.
 */
function initializeRibbonIdToCmdIdMap() {
    MailRibbonIdToCmdIdMap = new Map();

    MailRibbonIdToCmdIdMap.set(MailRibbonControlId.AddressBook, MenuItemType.BadItemType)
        .set(MailRibbonControlId.Archive, MenuItemType.Archive)
        .set(MailRibbonControlId.AssignPolicy, MenuItemType.Ribbon_AssignPolicy)
        .set(MailRibbonControlId.Block, MenuItemType.Block)
        .set(MailRibbonControlId.BrowseGroups, MenuItemType.BadItemType)
        .set(MailRibbonControlId.Categorize, MenuItemType.Categories)
        .set(MailRibbonControlId.CreateRule, MenuItemType.InboxRule)
        .set(MailRibbonControlId.DeleteItem, MenuItemType.Ribbon_Delete)
        .set(MailRibbonControlId.FlagUnflag, MenuItemType.Ribbon_FlagUnflag)
        .set(MailRibbonControlId.GetAddIns, MenuItemType.BadItemType)
        .set(MailRibbonGroupId.Group_Find, MenuItemType.BadItemType)
        .set(MailRibbonGroupId.Group_Groups, MenuItemType.BadItemType)
        .set(MailRibbonGroupId.Group_Move, MenuItemType.BadItemType)
        .set(MailRibbonGroupId.Group_QuickSteps, MenuItemType.BadItemType)
        .set(MailRibbonGroupId.Group_Tags, MenuItemType.BadItemType)
        .set(MailRibbonControlId.IgnoreStopIgnore, MenuItemType.Ribbon_IgnoreStopIgnore)
        .set(MailRibbonControlId.ImmersiveReader, MenuItemType.ShowInImmersiveReader)
        .set(MailRibbonControlId.Insights, MenuItemType.SingleSelection)
        .set(MailRibbonControlId.JunkFlyout, MenuItemType.Ribbon_JunkNotJunk)
        .set(MailRibbonControlId.JunkNotJunk, MenuItemType.Ribbon_JunkNotJunk)
        .set(MailRibbonControlId.MarkComplete, MenuItemType.BadItemType)
        .set(MailRibbonControlId.Move, MenuItemType.Move)
        .set(MailRibbonControlId.NewEvent, MenuItemType.BadItemType)
        .set(MailRibbonControlId.NewGroup, MenuItemType.BadItemType)
        .set(MailRibbonControlId.NewItems, MenuItemType.BadItemType)
        .set(MailRibbonControlId.NewMessage, MenuItemType.Ribbon_NewMessage)
        .set(MailRibbonControlId.NewMessageSplitButton, MenuItemType.BadItemType)
        .set(MailRibbonControlId.NewNote, MenuItemType.Ribbon_NewNote)
        .set(MailRibbonControlId.NewTask, MenuItemType.BadItemType)
        .set(MailRibbonControlId.OtherFolder, MenuItemType.BadItemType)
        .set(MailRibbonControlId.PinUnpin, MenuItemType.Ribbon_PinUnpin)
        .set(MailRibbonControlId.Print, MenuItemType.Print)
        .set(MailRibbonControlId.ReadAloud, MenuItemType.SingleSelection)
        .set(MailRibbonControlId.ReadUnread, MenuItemType.Ribbon_ReadUnread)
        .set(MailRibbonControlId.ReplyWithMeeting, MenuItemType.ReplyWithMeeting)
        .set(MailRibbonControlId.ReportMessage, MenuItemType.SingleSelection)
        .set(MailRibbonControlId.RespondForward, MenuItemType.Ribbon_Forward)
        .set(MailRibbonControlId.RespondReply, MenuItemType.Ribbon_Reply)
        .set(MailRibbonControlId.RespondReplyAll, MenuItemType.Ribbon_ReplyAll)
        .set(MailRibbonControlId.SetQuickActions, MenuItemType.BadItemType)
        .set(MailRibbonControlId.ShowMessageOptions, MenuItemType.EnterpriseOnly)
        .set(MailRibbonControlId.Snooze, MenuItemType.Schedule)
        .set(MailRibbonControlId.Sweep, MenuItemType.Ribbon_Sweep)
        .set(MailRibbonControlId.Undo, MenuItemType.Ribbon_Undo)
        .set(MailRibbonControlId.Unsnooze, MenuItemType.BadItemType);
}
